import { Link, useNavigate } from "react-router-dom";

function OpenPage() {
    return (
        <>
  <section data-bs-version="5.1" class="menu menu2 cid-tP2PVGIG6B" once="menu" id="menu2-2">
    
    <nav class="navbar navbar-dropdown navbar-fixed-top navbar-expand-lg">
        <div class="container-fluid">
            <div class="navbar-brand">
                <span class="navbar-logo">
                    
                        <img src="images/logo.png" alt="Team Soul" style={{height: "3rem"}} />
                    
                </span>
                <span class="navbar-caption-wrap"><a class="navbar-caption text-black display-7" href="#">Team Soul</a></span>
            </div>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-bs-toggle="collapse" data-target="#navbarSupportedContent" data-bs-target="#navbarSupportedContent" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                <div class="hamburger">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav nav-dropdown" data-app-modern-menu="true"><li class="nav-item"><a class="nav-link link text-black display-4" href="#features24-7">Steps</a></li>
                    <li class="nav-item"><a class="nav-link link text-black display-4" href="#features015-4">Features</a></li>
                    <li class="nav-item"><a class="nav-link link text-black display-4" href="#content17-e">Measures</a>
                    </li></ul>
                
                    <Link to="/login"><div class="navbar-buttons mbr-section-btn"><a class="btn btn-primary display-4" href="#"><span class="mobi-mbri mobi-mbri-user-2 mbr-iconfont mbr-iconfont-btn"></span>Login</a></div></Link>
            </div>
        </div>
    </nav>
</section>

<section data-bs-version="5.1" class="header11 cid-tP30MkBH7o" id="header11-g">

    

    
    

    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-md-6 image-wrapper">
                <img class="w-100" src="./images/ani4.gif" alt="y" />
            </div>
            <div class="col-12 col-md">
                <div class="text-wrapper text-center">
                    <h1 class="mbr-section-title mbr-fonts-style mb-3 display-2"><strong>Vaayu Sansoochak</strong></h1>
                    <p class="mbr-text mbr-fonts-style display-7">It is a specialized device designed to monitor and detect harmful gases produced in sewage systems. It provides early warning alerts, helping operators take timely action to mitigate gas-related issues and protect the environment and human health.</p>
                    <Link to="/login"><div class="mbr-section-btn mt-3"><a class="btn btn-primary display-7">Get Started</a></div></Link>
                </div>
            </div>
        </div>
    </div>
</section>

<section data-bs-version="5.1" class="features24 cid-tP2RiP8voI" id="features24-7">

    

    
    
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="card-wrapper mb-4">
                    <div class="card-box align-center">
                        <h4 class="card-title mbr-fonts-style mb-4 display-2">
                            <strong>Steps</strong>
                        </h4>
                        
                        
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <div class="item first mbr-flex p-4">
                    <div class="icon-wrap w-100">
                        <div class="icon-box">
                            <span class="step-number mbr-fonts-style display-5">1</span>
                        </div>
                    </div>

                    <div class="text-box">
                        <h4 class="icon-title card-title mbr-black mbr-fonts-style display-7"><strong>Device Activation</strong></h4>
                        <h5 class="mbr-text mbr-black mbr-fonts-style display-4">Turn on the device and wear it in your helmet.</h5>
                    </div>
                </div>

            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <div class="item mbr-flex p-4">
                    <div class="icon-wrap w-100">
                        <div class="icon-box">
                            <span class="step-number mbr-fonts-style display-5">2</span>
                        </div>
                    </div>
                    <div class="text-box">
                        <h4 class="icon-title card-title mbr-black mbr-fonts-style display-7"><strong>Data Access via Website</strong></h4>
                        <h5 class="mbr-text mbr-black mbr-fonts-style display-4">Access data collected by the device through a dedicated website.</h5>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <div class="item mbr-flex p-4">
                    <div class="icon-wrap w-100">
                        <div class="icon-box">
                            <span class="step-number mbr-fonts-style display-5">3</span>
                        </div>
                    </div>
                    <div class="text-box">
                        <h4 class="icon-title card-title mbr-black mbr-fonts-style display-7"><strong>Data Access via&nbsp; Mobile App</strong></h4>
                        <h5 class="mbr-text mbr-black mbr-fonts-style display-4">Seamlessly access and control device functions through a mobile app.</h5>
                    </div>
                </div>
            </div>
            
            
            
            
            
        </div>
    </div>
</section>

<section data-bs-version="5.1" class="features15 cid-tP2QFd22iA" id="features015-4">
	

	
	
	<div class="container">
		<div class="row justify-content-center">
			<div class="col-12 content-head">
				<div class="mbr-section-head mb-5">
					<h4 class="mbr-section-title mbr-fonts-style align-center mb-0 display-2">
					  <strong>Features</strong>
					</h4>
					
				  </div>
			</div>
		</div>
		<div class="row justify-content-center">
			
			<div class="item features-without-image col-12 col-lg-4 active">
				<div class="item-wrapper">
					<div class="img-wrapper">
						<img src="assets/images/co.png" alt="r" data-slide-to="1" data-bs-slide-to="1" />
					</div>
					<div class="card-box">
						<h4 class="card-title mbr-fonts-style mb-0 display-7">
							<strong>Gas Detector</strong></h4>
						<h5 class="card-text mbr-fonts-style mt-3 display-7">Carbon monoxide Dectector</h5>
					</div>
				</div>
			</div>
			<div class="item features-without-image col-12 col-lg-4">
				<div class="item-wrapper">
					<div class="img-wrapper">
						<img src="assets/images/fire-logo-vector-19229678.jpeg" alt="r" data-slide-to="2" data-bs-slide-to="2" />
					</div>
					<div class="card-box">
						<h4 class="card-title mbr-fonts-style mb-0 display-7"><strong>Gas Detector</strong></h4>
						<h5 class="card-text mbr-fonts-style mt-3 display-7">Methane(Flamable Gasess) Dectector</h5>
					</div>
				</div>
			</div><div class="item features-without-image col-12 col-lg-4">
				<div class="item-wrapper">
					<div class="img-wrapper">
						<img src="assets/images/hydrogen-sulphide.png" alt="r" data-slide-to="3" data-bs-slide-to="3" />
					</div>
					<div class="card-box">
						<h4 class="card-title mbr-fonts-style mb-0 display-7"><strong>Gas Detector</strong></h4>
						<h5 class="card-text mbr-fonts-style mt-3 display-7">Hydrogen sulphide Gas Dectector</h5>
					</div>
				</div>
			</div><div class="item features-without-image col-12 col-lg-4">
				<div class="item-wrapper">
					<div class="img-wrapper">
						<img src="assets/images/so2.png" alt="r" data-slide-to="6" data-bs-slide-to="7" />
					</div>
					<div class="card-box">
						<h4 class="card-title mbr-fonts-style mb-0 display-7"><strong>Gas Detector</strong></h4>
						<h5 class="card-text mbr-fonts-style mt-3 display-7">Sulphur dioxide Gas Dectector</h5>
					</div>
				</div>
			</div><div class="item features-without-image col-12 col-lg-4">
				<div class="item-wrapper">
					<div class="img-wrapper">
						<img src="assets/images/ammonia.png" alt="r" data-slide-to="7" data-bs-slide-to="7" />
					</div>
					<div class="card-box">
						<h4 class="card-title mbr-fonts-style mb-0 display-7"><strong>Gas Detector</strong></h4>
						<h5 class="card-text mbr-fonts-style mt-3 display-7">Ammonia Gas Dectector</h5>
					</div>
				</div>
			</div><div class="item features-without-image col-12 col-lg-4">
				<div class="item-wrapper">
					<div class="img-wrapper">
						<img src="assets/images/istockphoto-1152189152-612x612.jpg" alt="r" data-slide-to="6" data-bs-slide-to="7" />
					</div>
					<div class="card-box">
						<h4 class="card-title mbr-fonts-style mb-0 display-7"><strong>Safety Alarm</strong></h4>
						<h5 class="card-text mbr-fonts-style mt-3 display-7">Alerting during emergencies.</h5>
					</div>
				</div>
			</div><div class="item features-without-image col-12 col-lg-4">
				<div class="item-wrapper">
					<div class="img-wrapper">
						<img src="assets/images/wifi-internet-logo-vector-20993784.jpeg" alt="r" data-slide-to="7" data-bs-slide-to="7" />
					</div>
					<div class="card-box">
						<h4 class="card-title mbr-fonts-style mb-0 display-7">
							<strong>Wifi-connectivity</strong>
						</h4>
						<h5 class="card-text mbr-fonts-style mt-3 display-7">Facilitates wireless data exchange.</h5>
					</div>
				</div>
			</div><div class="item features-without-image col-12 col-lg-4">
				<div class="item-wrapper">
					<div class="img-wrapper">
						<img src="assets/images/how-to-add-a-push-notification-icon-1.png" alt="r" data-slide-to="7" data-bs-slide-to="8" />
					</div>
					<div class="card-box">
						<h4 class="card-title mbr-fonts-style mb-0 display-7">
							<strong>Mobile Notification</strong></h4>
						<h5 class="card-text mbr-fonts-style mt-3 display-7">Mobile notifications provide timely alerts.</h5>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<section data-bs-version="5.1" class="content17 cid-tP2X3VclMi" id="content17-e">

    

    
    
    
    <div class="container">
        
            <div class="row justify-content-center">
                <div class="col-12 col-md-10">
                    <div class="section-head align-center mb-4">
                        <h3 class="mbr-section-title mb-0 mbr-fonts-style display-2">
                            <strong>Safety Measures</strong></h3>
                        
                    </div>
                    
                    <div id="bootstrap-toggle" class="toggle-panel accordionStyles tab-content">
                        <div class="card mb-3">
                            <div class="card-header" role="tab" id="headingOne">
                                <a role="button" class="collapsed panel-title text-black" data-toggle="collapse" data-bs-toggle="collapse" data-core="" href="#collapse1_14" aria-expanded="false" aria-controls="collapse1">
                                    <h6 class="panel-title-edit mbr-fonts-style mb-0 display-7"><strong>Check for Substances</strong></h6>
                                    <span class="sign mbr-iconfont mbri-arrow-down"></span>
                                </a>
                            </div>
                            <div id="collapse1_14" class="panel-collapse noScroll collapse" role="tabpanel" aria-labelledby="headingOne">
                                <div class="panel-body">
                                    <p class="mbr-fonts-style panel-text display-7">Measures the level of carbon monoxide, hydrogen-sulphide, Sulphur dioxide, ammonia, methane and other flameable gasses levels inside the confined space and deterimines wheather further procedures can be carried out or not.</p>
                                </div>
                            </div>
                        </div>
                        <div class="card mb-3">
                            <div class="card-header" role="tab" id="headingTwo">
                                <a role="button" class="collapsed panel-title text-black" data-toggle="collapse" data-bs-toggle="collapse" data-core="" href="#collapse2_14" aria-expanded="false" aria-controls="collapse2">
                                    <h6 class="panel-title-edit mbr-fonts-style mb-0 display-7"><strong>Duration of Exposure</strong></h6>
                                    <span class="sign mbr-iconfont mbri-arrow-down"></span>
                                </a>

                            </div>
                            <div id="collapse2_14" class="panel-collapse noScroll collapse" role="tabpanel" aria-labelledby="headingTwo">
                                <div class="panel-body">
                                    <p class="mbr-fonts-style panel-text display-7">After the levels of the gasses present inside are measured it is transmitted to database and the safe duration of time in which the cleaning and mantainace can be done without endangering a person's health is calculated using a machine learning algorithm.</p>
                                </div>
                            </div>
                        </div>
                        <div class="card mb-3">
                            <div class="card-header" role="tab" id="headingThree">
                                <a role="button" class="collapsed panel-title text-black" data-toggle="collapse" data-bs-toggle="collapse" data-core="" href="#collapse3_14" aria-expanded="false" aria-controls="collapse3">
                                    <h6 class="panel-title-edit mbr-fonts-style mb-0 display-7"><strong>Alert Feature</strong></h6>
                                    <span class="sign mbr-iconfont mbri-arrow-down"></span>
                                </a>
                            </div>
                            <div id="collapse3_14" class="panel-collapse noScroll collapse" role="tabpanel" aria-labelledby="headingThree">
                                <div class="panel-body">
                                    <p class="mbr-fonts-style panel-text display-7">If the calculated duration of exposure is reached a alert feature where a buzzer and a led light will go off to signal for returning to safety.</p>
                                </div>
                            </div>
                        </div>
                        
                        
                        
                    </div>
                </div>
            </div>
        </div>
</section>

<section data-bs-version="5.1" class="footer3 cid-tP2RsSI2si" once="footers" id="footer3-8">

    

    

    <div class="container">
        <div class="media-container-row align-center mbr-white">
            
            <div class="row social-row">
                <div class="social-list align-right pb-2">
                    
                    
                    
                    
                    
                    
                <div class="soc-item">
                        <a href="#" target="_blank">
                            <span class="socicon-twitter socicon mbr-iconfont mbr-iconfont-social"></span>
                        </a>
                    </div><div class="soc-item">
                        <a href="#" target="_blank">
                            <span class="socicon-facebook socicon mbr-iconfont mbr-iconfont-social"></span>
                        </a>
                    </div><div class="soc-item">
                        <a href="#" target="_blank">
                            <span class="socicon-youtube socicon mbr-iconfont mbr-iconfont-social"></span>
                        </a>
                    </div><div class="soc-item">
                        <a href="#" target="_blank">
                            <span class="socicon-instagram socicon mbr-iconfont mbr-iconfont-social"></span>
                        </a>
                    </div><div class="soc-item">
                        <a href="#" target="_blank">
                            <span class="socicon-googleplus socicon mbr-iconfont mbr-iconfont-social"></span>
                        </a>
                    </div></div>
            </div>
            <div class="row row-copirayt">
                <p class="mbr-text mb-0 mbr-fonts-style mbr-white align-center display-7">
                    © Copyright Team Soul. All Rights Reserved.
                </p>
            </div>
        </div>
    </div>
</section>

        </>
    );
}

export default OpenPage;